import { render, staticRenderFns } from "./HeaderCranialSymposium.vue?vue&type=template&id=ee56db2a&"
import script from "./HeaderCranialSymposium.vue?vue&type=script&lang=js&"
export * from "./HeaderCranialSymposium.vue?vue&type=script&lang=js&"
import style0 from "./HeaderCranialSymposium.vue?vue&type=style&index=0&id=ee56db2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports